import { render, staticRenderFns } from "./MenuItemGroupsAbs.vue?vue&type=template&id=07e47b14&scoped=true&"
import script from "./MenuItemGroupsAbs.vue?vue&type=script&lang=js&"
export * from "./MenuItemGroupsAbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e47b14",
  null
  
)

export default component.exports